import React from "react";

function MaterialImage({
  refMaterial,
  imgsByRef,
  size = 26,
  placeholderWidth,
  title = "Abrir imagem",
}) {
  const ref = String(refMaterial || "").trim();
  const url = ref ? imgsByRef?.[ref] || "" : "";

  if (!url) {
    return (
      <span
        style={{
          display: "inline-block",
          width: placeholderWidth ?? size + 6,
        }}
      />
    );
  }

  return (
    <img
      src={url}
      alt={ref}
      title={title}
      style={{
        width: size,
        height: size,
        objectFit: "contain",
        borderRadius: 6,
        cursor: "pointer",
        border: "1px solid #eee",
        background: "#fff",
      }}
      onClick={() => window.open(url, "_blank", "noopener,noreferrer")}
    />
  );
}

export default React.memo(MaterialImage);
